// Types / Interfaces / Enums
import { AIChatConversationTimePeriod, PromptSuggestionCategory } from 'AIChatApp/enums/ai-chat.enum';
export const WELCOME_MESSAGE = 'Ask anything about financial news, securities, funds, ETFs, SEC Filings, or start a project.';
export const CANNOT_ANSWER_RESPONSE = 'Sorry, I could not find the answer to that question.';
export const AI_CHAT_CONVERSATION_TIME_PERIOD_LABELS = {
    [AIChatConversationTimePeriod.TODAY]: 'Today',
    [AIChatConversationTimePeriod.YESTERDAY]: 'Yesterday',
    [AIChatConversationTimePeriod.LAST_WEEK]: 'Last week',
    [AIChatConversationTimePeriod.LAST_30_DAYS]: 'Last 30 days',
    [AIChatConversationTimePeriod.OLDER]: 'Older',
};
export const PROMPT_SUGGESTION_PROPERTIES = {
    [PromptSuggestionCategory.RESEARCH_AND_MONITOR]: {
        label: 'Research & Monitor',
        icon: 'icon-chart-ohlc',
    },
    [PromptSuggestionCategory.ANALYZE_AND_SYNTHESIZE]: {
        label: 'Analyze & Synthesize',
        icon: 'icon-browse',
    },
    [PromptSuggestionCategory.START_PROJECT]: {
        label: 'Start a Project',
        icon: 'icon-lightbulb',
    },
};
export const MARKDOWN_RENDERER_OPTIONS = {
    link: (href, _title, text) => {
        // Remove the domain from links so that they always link to the current environment
        const cleanedHref = href.replace(/^https?:\/\/ycharts.com/, '');
        // Make links easier to see and always open them in a new tab
        return `<a href="${cleanedHref}" class="text-underline text-blue" target="_blank">${text}</a>`;
    },
    text: (text) => {
        // Add colors for percentage change values
        const percentageRegex = /(^|\(|\s)([-+]?)(\d+(?:,\d{3})*(?:\.\d+)?)%/g;
        return text.replace(percentageRegex, (fullMatch, lead, sign, num) => {
            const percentage = `${sign ?? ''}${num}%`;
            if (sign === '-') {
                return `${lead}<span class="text-red">${percentage}</span>`;
            }
            if (sign === '+') {
                return `${lead}<span class="text-green">${percentage}</span>`;
            }
            return fullMatch;
        });
    },
    table: (header, body) => {
        const tpl = document.createElement('template');
        tpl.innerHTML = `<table><thead>${header}</thead><tbody>${body}</tbody></table>`;
        const tableEl = tpl.content.querySelector('table');
        const thead = tableEl.querySelector('thead');
        const tbody = tableEl.querySelector('tbody');
        // Build Header
        const headerRow = thead.querySelector('tr');
        if (headerRow) {
            const headerCells = Array.from(headerRow.children);
            headerCells.forEach((origEl, idx) => {
                const rawText = (origEl.textContent ?? '').trim();
                const td = document.createElement('td');
                if (idx === 0) {
                    td.className = 'table-dynamic-name';
                    td.innerHTML = `<div class="form-label form-label-thin">${rawText}</div>`;
                }
                else {
                    td.className = 'text-right colTxtShort';
                    td.innerHTML = rawText ? `<strong>${rawText}</strong>` : '';
                }
                origEl.replaceWith(td);
            });
        }
        // Build Body
        Array.from(tbody.querySelectorAll('tr')).forEach((trEl) => {
            const tds = Array.from(trEl.children);
            tds.forEach((origEl, idx) => {
                const newTd = document.createElement('td');
                const content = origEl.innerHTML;
                if (idx === 0) {
                    newTd.className = 'table-dynamic-name';
                }
                else {
                    const existing = origEl.getAttribute('class');
                    newTd.setAttribute('class', existing ? `text-right ${existing}` : 'text-right');
                }
                newTd.innerHTML = content;
                origEl.replaceWith(newTd);
            });
        });
        return `
            <div class="panel-data">
              <div class="panel-content">
                <div class="company-financials-table-wrap">
                  <div class="ai-chat-table-section company-financials-table">
                    <table class="table table-dense table-striped">
                      ${thead.outerHTML}
                      ${tbody.outerHTML}
                    </table>
                  </div>
                </div>
              </div>
            </div>
        `;
    },
};
export const INCOMPLETE_MARKDOWN_LINK_REGEX = /\[[^\]]*\]\([^)]*$|\[[^\]]*$/g;
